import * as apiBookmark from '@/api/bookmark'
import * as _ from 'lodash'
import store from '@/store'
import { isFromAdminSystem } from '@/util/common'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    complete: false,
    canload: true,
    start: 0,
    per_page: 30,
    count: null,
    currentId: null
  }

  return defaults
}

const viewLater = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists, list => list.bookmark_id === state.currentId)
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    setLists: (state, lists) => {
      state.lists.push(...lists)
    },
    setStart: (state, num) => {
      state.start = num
    },
    deleteCount: (state) => {
      state.count = 0
    },
    setCount: (state, num) => {
      state.count = num
    },
    subtractionCount: (state) => {
      state.count--
    },
    setComplete: (state) => {
      state.complete = true
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
    },
    resetComplete: (state) => {
      state.complete = false
    },
    resetAll: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentId = id
    },
    deleteList: (state, index) => {
      state.lists.splice(index, 1)
    }
  },
  actions: {
    getCount: ({ commit, state }) => {
      const params = {
        type: 2, // 2(後で見る)
        tags: [],
        key: '' // qa(QA)、knowledge(ナレッジ)、両方取得なので空
      }
      apiBookmark
        .count(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('setCount', data.count)
          }
        })
    },
    getLists: async ({ commit, state, dispatch }) => {
      const params = {
        start: state.start,
        per_page: state.per_page,
        search_order: 'created', // created(作成日順)
        ascending: 'desc',
        type: 2, // 2(後で見る)
        tags: [],
        key: '' // qa(QA)、knowledge(ナレッジ)、両方取得なので空
      }
      if (state.canload) {
        commit('setCanload', false)
        const res = await apiBookmark
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              const { lists } = data
              if (lists && lists.length > 0) {
                const start = state.start + lists.length
                await commit('setStart', start)
                await commit('setLists', lists)
                commit('setCanload', true)
              } else {
                commit('setCanload', true)
                commit('setComplete')
              }
            } else {
              if (!isFromAdminSystem()) {
                // status=その他: エラーダイアログを表示
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
            return data
          })
        return res
      }
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id) 
    },
    delete: async ({ commit, state }, params) => {
      await apiBookmark
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const index = _.findIndex(state.lists, list => list.bookmark_id === params.id)
            commit('deleteList', index)
            commit('subtractionCount')
          }
        })
    },
    deleteAll: async ({ commit, state }, params) => {
      await apiBookmark
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('resetLists')
            commit('deleteCount')
            commit('setComplete')
          }
        })
    }
  }
}

export default viewLater
